<template>
  <div>
    <TopSection />
    <AboutSection />
    <InformativeSection />
    <TrademarksSection />
  </div>
</template>

<script>
import AboutSection from "../components/sections/AboutSection";
import InformativeSection from "../components/sections/InformativeSection";
import TopSection from "../components/sections/TopSection.vue";
import TrademarksSection from "../components/sections/TrademarksSection";

export default {
  components: {
    TrademarksSection,
    AboutSection,
    InformativeSection,
    TopSection,
  },
};
</script>
